import { useSelector } from 'react-redux'
import { sortBy } from 'lodash'
import { useExcludedGamesTable } from '@/views/bonus-engine/hooks'

import { Excluded } from '@/state/excluded-games/models'
import { ApplicationState } from '@/state/root.models'
import { TableGenericComponent } from '@/views/components'

import { ExcludedGamesFormComponent, ExcludedGamesRowComponent } from './'
import { Box } from '@mui/system'

export const ExcludedGamesTableComponent = () => {
  const { handleEditGame, handleDeleteGame, headCells } =
    useExcludedGamesTable()

  const { excludedGames } = useSelector(
    ({ excludedGames }: ApplicationState) => excludedGames,
  )

  const sortedRows = sortBy(excludedGames.games, 'gameDescription')
  const body =
    sortedRows?.map((row: Excluded) => {
      return (
        <ExcludedGamesRowComponent
          key={`${row.gameId} - ${row.gameProviderId}`}
          row={row}
          handleDeleteGame={handleDeleteGame}
          handleEditGame={handleEditGame}
        />
      )
    }) || []

  return (
    <Box minHeight={400}>
      <TableGenericComponent<Excluded>
        headCells={headCells}
        rowLength={sortedRows.length}
        isLoading={false}
        body={body}
        hasAction={true}
      />
      <ExcludedGamesFormComponent />
    </Box>
  )
}
